export { default } from './component';
export { useCardDivider } from './hook';